import { render } from "./BaseDropdown.vue?vue&type=template&id=15d14320&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts"

import "./BaseDropdown.vue?vue&type=style&index=0&id=15d14320&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15d14320"

export default script